import { useEffect } from 'react';
import { useDispatch } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import styled from '@emotion/styled';
import { Heading } from 'shared/components';
import { BaseRow } from 'shared/containers';
import { NextStepButton } from 'shared/buttons';
import { SYNC, sync, NAVIGATE } from 'shared/wizard/actions';
import { flowTypes } from '../config';
import ExistingFlowSvg from 'images/orv/existing-orv.svg';
import NewFlowSvg from 'images/orv/new-orv.svg';

const Container = styled.div`
  width: 100%;
  max-width: 466px;

  ${Heading} {
    margin-bottom: 8px;
  }
`;

const StepContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 24px;
`;

const StepButton = styled(BaseRow)`
  display: block;
  width: 220px;
  padding: 20px;
  margin-bottom: 0px;
  text-align: left;
  cursor: pointer;

  &:hover {
    font-weight: 800;
  }

  > svg {
    display: block;
    height: 40px;
    fill: ${({ theme }) => theme.primaryColor};

    [class$='highlight'] {
      fill: ${({ theme }) => theme.highlightColor};
    }
  }

  > span {
    display: block;
    margin: 16px 0;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.6px;
  }

  @media ${({ theme }) => theme.mobile} {
    width: 100%;
    padding: 40px;

    display: flex;
    flex-direction: column;
    align-items: center;

    font-weight: 800;
    text-align: center;

    &:first-of-type {
      margin-bottom: 16px;
    }

    > span {
      max-width: 240px;
    }

    br {
      display: none;
    }
  }
`;

const FlowStep = ({ flowType, children }) => {
  const dispatch = useDispatch();

  return (
    <StepButton
      as="button"
      onClick={() => {
        sync(dispatch)('flow', flowType);
        dispatch({ type: NAVIGATE, delta: 1 });
      }}
    >
      {children}
      <NextStepButton as="div">Berekenen</NextStepButton>
    </StepButton>
  );
};

const Flow = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: SYNC, syncing: false });
    analytics.send('Navigeer', 'ORV voorpagina');
  }, []);

  return (
    <Container>
      <Heading>Ik wil..</Heading>
      <StepContainer>
        <FlowStep flowType={flowTypes.new}>
          <NewFlowSvg />
          <span>een nieuwe overlijdensrisico-verzekering</span>
        </FlowStep>
        <FlowStep flowType={flowTypes.existing}>
          <ExistingFlowSvg />
          <span>
            Besparen op mijn huidige <br /> overlijdensrisico-verzekering
          </span>
        </FlowStep>
      </StepContainer>
    </Container>
  );
};

export default Flow;
